module.exports = __webpack_public_path__ + "static/media/underdev.2a3410f8.png";